import { createSlice } from '@reduxjs/toolkit';
import { resetOnLogout } from '~/reducers/common-actions';
import { idUtils } from '~/utils/id-utils';

const InitialState = [];

export const selectedMapStopsSlice = createSlice({
    name: 'selectedMapStops',
    initialState: InitialState,
    reducers: {
        addSelectedMapStop: (state, action) => {
            const hasStop = state.includes(action.payload);
            if (!hasStop) {
                state.push(action.payload);
            }
            return state;
        },
        addSelectedMapStops: (state, action) => {
            action.payload.forEach((stop) => {
                const hasStop = state.includes(stop);
                if (!hasStop) {
                    state.push(stop);
                }
            });
            return state;
        },
        setSelectedMapStop: (state, action) => {
            return [action.payload];
        },
        replaceSelectedMapStop: (state, action) => {
            return action.payload;
        },
        removeSelectedMapStop: (state, action) => {
            const index = state.indexOf(action.payload);
            if (index !== -1) {
                state.splice(index, 1);
            }
            return state;
        },
        resetSelectedMapStops: () => {
            return InitialState;
        },
        updateSelectedMapStops: (state, action) => {
            const hasStop = state.includes(action.payload);
            if (hasStop) {
                const filteredState = state.filter(
                    (each) => each !== action.payload
                );
                return filteredState;
            }
            if (!hasStop) {
                state.push(action.payload);
            }
            return state;
        },
        setSelectedMapStops: (state, action) => {
            return action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetOnLogout, () => {
            return [];
        });
    }
});

export const {
    replaceSelectedMapStop,
    addSelectedMapStop,
    addSelectedMapStops,
    removeSelectedMapStop,
    setSelectedMapStop,
    resetSelectedMapStops,
    updateSelectedMapStops,
    setSelectedMapStops
} = selectedMapStopsSlice.actions;

export const selectSelectedMapStops = (state) => state.selectedMapStops;

export const selectAreTaskStopsSelected = (taskId) => (state) =>
    state.selectedMapStops.some((combinedId) => combinedId.includes(taskId));

export const selectSelectedStopTaskIds = (state) => {
    return state.selectedMapStops.map((combinedIds) => {
        const [taskId] = idUtils.splitCombinedId(combinedIds).reverse();
        return taskId;
    });
};

export default selectedMapStopsSlice.reducer;
